import { render, staticRenderFns } from "./SignSimple.vue?vue&type=template&id=d20aa40a&scoped=true"
import script from "./SignSimple.vue?vue&type=script&lang=js"
export * from "./SignSimple.vue?vue&type=script&lang=js"
import style0 from "./SignSimple.vue?vue&type=style&index=0&id=d20aa40a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20aa40a",
  null
  
)

export default component.exports